import { msg } from '@gonfalon/messages/msg';
import { Tag } from '@launchpad-ui/components';

export function ControlChip({ className }: { className?: string }) {
  return (
    <Tag size="small" variant="info" className={className}>
      {msg('experiments.resultsTable.control')}
    </Tag>
  );
}
